module.exports = __webpack_public_path__ + "static/media/popup-img.b67486b2.svg";